export default __webpack_public_path__ + "static/media/gallery_01.9aac2a88.jpg";